"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'adPosition',
  components: {},
  data: function data() {
    return {
      list: [],
      listLoading: true,
      son_id: ''
    };
  },
  mounted: function mounted() {
    this.son_id = this.$route.query.son_id || '';
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var url = 'agentapi/son_ad_auths';
      this.$get(url, {
        son_id: this.son_id
      }).then(function (res) {
        _this.listLoading = false;
        _this.list = res;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 设置子级广告权限
     */
    setPer: function setPer(row) {
      var _this2 = this;
      var agree = row.son_has == 1 ? 0 : 1;
      this.$post('agentapi/switch_ad_position', {
        son_id: this.son_id,
        position_id: row.position_id,
        agree: agree
      }).then(function (res) {
        _this2.$message({
          message: '设置成功',
          type: 'success'
        });
        row.son_has = agree;
      });
    }
  }
};